import { apiRequest, invalidateCache } from './api.js';

export function createAccountsService(helium) {
	const accountsChannel = helium.factory('accounts:list', { data: [], pagination: {}, loading: false });
	const filtersChannel = helium.factory('accounts:filters', {
		search: '',
		plan: '',
		status: '',
		page: 1,
		limit: 20,
		sort: 'email',
		order: 'asc'
	});
	
	const getAll = async (filters = {}, signal) => {
		const params = {
			...filters,
			page: filters.page || 1,
			limit: filters.limit || 20
		};
		
		return await apiRequest('/api/v1/admin/accounts', { params, signal }, true);
	};
	
	const getById = async (accountId, signal) => {
		return await apiRequest(`/api/v1/admin/accounts/${accountId}`, { signal }, true);
	};
	
	const update = async (accountId, data, signal) => {
		invalidateCache('/api/v1/admin/accounts');
		return await apiRequest(`/api/v1/admin/accounts/${accountId}`, {
			method: 'PATCH',
			body: JSON.stringify(data),
			signal
		});
	};
	
	const setFilters = (newFilters) => {
		filtersChannel.send(filters => ({ ...filters, ...newFilters }));
	};
	
	return { accountsChannel, filtersChannel, getAll, getById, update, setFilters };
}
